import { Checkbox } from 'antd'
import { useEffect } from 'react'
import { ConsentCheckWrapper, VipSyncConsentText, VipSyncConsentWrapper, VipSyncTextTitle } from '../../../AddItem.styles'
import { useAnalytics } from '../../../../../app/data/AnalyticsProvider';
import { VipSyncSelectedInstitutionRow } from './VipSyncIntro';
import { successNotification } from '../../../../../layout/components/Notifications/notifications';

export const VipSyncManualConsent = ({ isConsentApproved, setIsConsentApproved, userStore, item, isActivationFlow }) => {
  const { mixpanelTrack } = useAnalytics();

  useEffect(() => {
    if (!isActivationFlow) {
      mixpanelTrack('VIP Sync Service Viewed', {
        step_name: 'Grant read-only access',
        step_number: 2,
        institution: item.name,
        url: window.location.href
      });
    }
    // return () => {}
  }, [mixpanelTrack, item.name, isActivationFlow])

  const handleCopyText = () => {
    navigator.clipboard.writeText(`vip-sync+${userStore.data?.id}@vyzer.co`);
    successNotification('Email copied')
  }

  return (
    <VipSyncConsentWrapper isActivationFlow={isActivationFlow}>
      <VipSyncSelectedInstitutionRow item={item} />
      <VipSyncTextTitle>
        Grant read-only access in your portal
      </VipSyncTextTitle>
      <VipSyncConsentText style={{ textAlign: 'center' , marginTop: '20px' , paddingBottom: '12px' }}>
        {`To sync your data, add the following email as an\nauthorized user in your ${item.name} portal:`}
      </VipSyncConsentText>
      <VipSyncConsentText style={{ display: 'flex', alignItems: 'center', gap: '6px'  }}>
        vip-sync+{userStore.data?.id}@vyzer.co <span style={{ color: '#2565E7' , cursor: 'pointer' , display: 'flex', alignItems: 'center' , gap:'4px'}} onClick={handleCopyText}><CopySvg/>Copy</span>
      </VipSyncConsentText>
      <ConsentCheckWrapper onClick={() => { setIsConsentApproved(!isConsentApproved) }}>
        <Checkbox checked={isConsentApproved}></Checkbox>
        <div style={{ ...(!isActivationFlow ? { maxWidth: '440px' } : {}) }}>I have successfully granted read-only access in my portal</div>
      </ConsentCheckWrapper>
    </VipSyncConsentWrapper>
  )
}

const CopySvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <rect x="4.375" y="5.25" width="9.375" height="11.25" rx="0.625" stroke="#2565E7" stroke-width="1.25"/>
  <path d="M7.5 2.75H15C15.6904 2.75 16.25 3.30964 16.25 4V12.75" stroke="#2565E7" stroke-width="1.25" stroke-linecap="round"/>
</svg>
)